/* global axios */
import ApiClient from './ApiClient';

class TasksAPI extends ApiClient {
  constructor() {
    super('tasks', { accountScoped: true });
  }

  getForConversation(conversationId) {
    return axios.get(`${this.baseUrl()}/conversations/${conversationId}/tasks`);
  }

  createForConversation({ conversationId, title, description, dueAt, assigneeId }) {
    return axios.post(
      `${this.baseUrl()}/conversations/${conversationId}/tasks`,
      { task: { title, description, due_at: dueAt, assignee_id: assigneeId } }
    );
  }

  updateForConversation({ conversationId, id, ...changes }) {
    return axios.patch(
      `${this.baseUrl()}/conversations/${conversationId}/tasks/${id}`,
      { task: changes }
    );
  }

  deleteForConversation({ conversationId, id }) {
    return axios.delete(
      `${this.baseUrl()}/conversations/${conversationId}/tasks/${id}`
    );
  }

  getAll({ page = 1, status, assigneeId, dueBefore } = {}) {
    return axios.get(this.url, {
      params: { page, status, assignee_id: assigneeId, due_before: dueBefore },
    });
  }
}

export default new TasksAPI();
